import { createTheme } from "@mui/material";

export const theme = createTheme({
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
  typography: {
    fontFamily: "'Caveat', cursive",
  },
  palette: {
    background: {
      main: "#f6efe4",
    },
    backgroundSecondary: {
      main: "#fff8ef",
    },
    buttonHover: {
      main: "#efd3b7",
    },
    textMain: {
      main: "#774c35",
    },
    textSecondary: {
      main: "#9f6848",
    },
    primary: {
      main: "#9a5d3f",
    },
    secondary: {
      main: "#d7b28c",
    },
    text: {
      primary: "#3f2b22",
      secondary: "#74584a",
    },
  },
});
